import { styled } from '@mui/material';
import { Box } from "@mui/material";

export const FooterContainer = styled(Box)`
  width: 100%;
  padding-left: 15px;
  margin-top: 20px;
  margin-bottom: 15px;
  display: none;
  padding-left: 30px;
  padding-right: 30px;

  @media print {
    display: flex;
  }
`;